"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareFegoEventChannel = exports.CHANNEL_MAP = void 0;
exports.reportFtEvent = reportFtEvent;
const tslib_1 = require("tslib");
/*eslint-disable no-eq-null,eqeqeq */
const fego_render_1 = tslib_1.__importDefault(require("@futuweb/fego-render"));
/**
 * 事件上报
 * @param { string } eventName 事件名称
 * @param { object } property 事件属性
 * @param { number } eventVersion 事件版本
 * @returns { void }
 */
function reportFtEvent(eventName, property = {}, eventVersion = 1) {
    var _a, _b;
    try {
        if ((_b = (_a = fego_render_1.default === null || fego_render_1.default === void 0 ? void 0 : fego_render_1.default.plugins) === null || _a === void 0 ? void 0 : _a.ftReport) === null || _b === void 0 ? void 0 : _b.ftReportIns) {
            // 测试环境使用设置isTest为true并配置host：http://test.hosts.futuoa.com/hosts/get-hosts-content?id=10244
            // FEGORender.plugins.ftReport.ftReportIns.setOptions({
            //     isTest: true,
            // });
            fego_render_1.default.plugins.ftReport.ftReportIns.sdReport({
                eventName,
                eventVersion,
                payload: property,
            });
        }
    }
    catch (error) {
        console.error('error:', error);
    }
}
// channel分享上报映射值
exports.CHANNEL_MAP = {
    niuyou: '4',
    chatRoom: '6',
    nnq: '5',
    wxFriend: '0',
    wxTimeline: '1',
    qq: '2',
    weibo: '3',
    facebook: '7',
    twitter: '8',
    whatsapp: '9',
    dingtalk: '16',
    line: '17',
    telegram: '18',
    other: '10',
    instagram: '12',
    sms: '13',
    email: '14',
    copy: '15'
};
exports.ShareFegoEventChannel = {
    facebook: 'facebook',
    twitter: 'x',
    telegram: 'telegram',
    xiaohongshu: 'xiaohongshu',
    reddit: 'reddit',
    wxFriend: 'wechat_friend', // 微信好友
    wechat_moments: 'wechat_moments', // 微信朋友圈
    qq: 'qq', // QQ
    weibo: 'sina_weibo', // 新浪微博
    chatRoom: 'chat', // 聊天室
    nnq: 'feed', // 牛牛圈、moomoo圈
    whatsapp: 'whats_app',
    sms: 'sms',
    email: 'email',
    copy: 'copy',
    instagram: 'instagram',
    dingtalk: 'dingding',
    line: 'line',
    more: 'more',
};
setTimeout(() => {
    var _a;
    let _window;
    if (window['Super_IPO_Season_click']) {
        return;
    }
    window['Super_IPO_Season_click'] = true;
    const actSign = 'Super_IPO_Season';
    const pageViwName = 'Super_IPO_Season_view';
    const pageViwName8s = 'Super_IPO_Season_view8s';
    const pageClickName = 'Super_IPO_Season_click';
    const getFtReport = (_a = window.FEGORender) === null || _a === void 0 ? void 0 : _a.getFtReport; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (!getFtReport) {
        return;
    }
    const ftReportIns = getFtReport();
    function getGlobalContent() {
        try {
            const url = new URL(location.href);
            const params = url.searchParams;
            const global_content_str = params.get('global_content') || '';
            return global_content_str;
        }
        catch (e) {
            console.error('解析global_content失败', e);
            return '';
        }
    }
    function reportClick() {
        ftReportIns == null || ftReportIns.sdReport({
            eventName: 'ClickPageEffectively',
            eventVersion: 3,
            eventEntity: 'NiuNiu',
            // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
            payload: {
                union_id: pageClickName,
                act_sign: actSign,
                global_content: getGlobalContent()
            }
        });
    }
    function reportViewPage() {
        ftReportIns == null || ftReportIns.sdReport({
            eventName: 'ViewPageEffectively',
            eventVersion: 3,
            eventEntity: 'NiuNiu',
            // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
            payload: {
                union_id: pageViwName,
                act_sign: actSign,
                global_content: getGlobalContent()
            }
        });
        setTimeout(() => {
            ftReportIns == null || ftReportIns.sdReport({
                eventName: 'ViewPageEffectively',
                eventVersion: 3,
                eventEntity: 'NiuNiu',
                // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
                payload: {
                    union_id: pageViwName8s,
                    act_sign: actSign,
                    event_duration: 8000,
                    global_content: getGlobalContent()
                }
            });
        }, 8000);
    }
    reportViewPage();
    window.addEventListener('click', (event) => {
        const target = event.target;
        // 判断父节点与本节点是否有a标签
        // 判断父节点与本节点是否有fegoevt-n-click 属性
        // 判断是否是button
        if (target.tagName === 'A'
            || target.closest('a')
            || target.hasAttribute('fegoevt-n-click')
            || target.closest('[fegoevt-n-click]')
            || target.tagName === 'BUTTON'
            || target.closest('button')) {
            reportClick();
        }
    });
}, 300);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwb3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmVwb3J0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVVBLHNDQW9CQzs7QUE5QkQscUNBQXFDO0FBQ3JDLCtFQUE4QztBQUU5Qzs7Ozs7O0dBTUc7QUFDSCxTQUFnQixhQUFhLENBQ3pCLFNBQVMsRUFDVCxRQUFRLEdBQUcsRUFBRSxFQUNiLFlBQVksR0FBRyxDQUFDOztJQUVoQixJQUFJLENBQUM7UUFDRCxJQUFJLE1BQUEsTUFBQSxxQkFBVSxhQUFWLHFCQUFVLHVCQUFWLHFCQUFVLENBQUUsT0FBTywwQ0FBRSxRQUFRLDBDQUFFLFdBQVcsRUFBRSxDQUFDO1lBQzdDLDJGQUEyRjtZQUMzRix1REFBdUQ7WUFDdkQsb0JBQW9CO1lBQ3BCLE1BQU07WUFDTixxQkFBVSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLFFBQVEsQ0FBQztnQkFDN0MsU0FBUztnQkFDVCxZQUFZO2dCQUNaLE9BQU8sRUFBRSxRQUFRO2FBQ3BCLENBQUMsQ0FBQztRQUNQLENBQUM7SUFDTCxDQUFDO0lBQUMsT0FBTyxLQUFLLEVBQUUsQ0FBQztRQUNiLE9BQU8sQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ25DLENBQUM7QUFDTCxDQUFDO0FBQ0QsaUJBQWlCO0FBQ0osUUFBQSxXQUFXLEdBQUc7SUFDdkIsTUFBTSxFQUFFLEdBQUc7SUFDWCxRQUFRLEVBQUUsR0FBRztJQUNiLEdBQUcsRUFBRSxHQUFHO0lBQ1IsUUFBUSxFQUFFLEdBQUc7SUFDYixVQUFVLEVBQUUsR0FBRztJQUNmLEVBQUUsRUFBRSxHQUFHO0lBQ1AsS0FBSyxFQUFFLEdBQUc7SUFDVixRQUFRLEVBQUUsR0FBRztJQUNiLE9BQU8sRUFBRSxHQUFHO0lBQ1osUUFBUSxFQUFFLEdBQUc7SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxJQUFJO0lBQ1YsUUFBUSxFQUFFLElBQUk7SUFDZCxLQUFLLEVBQUUsSUFBSTtJQUNYLFNBQVMsRUFBRSxJQUFJO0lBQ2YsR0FBRyxFQUFFLElBQUk7SUFDVCxLQUFLLEVBQUUsSUFBSTtJQUNYLElBQUksRUFBRSxJQUFJO0NBQ2IsQ0FBQztBQUVXLFFBQUEscUJBQXFCLEdBQUc7SUFDakMsUUFBUSxFQUFFLFVBQVU7SUFDcEIsT0FBTyxFQUFFLEdBQUc7SUFDWixRQUFRLEVBQUUsVUFBVTtJQUNwQixXQUFXLEVBQUUsYUFBYTtJQUMxQixNQUFNLEVBQUUsUUFBUTtJQUNoQixRQUFRLEVBQUUsZUFBZSxFQUFFLE9BQU87SUFDbEMsY0FBYyxFQUFFLGdCQUFnQixFQUFFLFFBQVE7SUFDMUMsRUFBRSxFQUFFLElBQUksRUFBRSxLQUFLO0lBQ2YsS0FBSyxFQUFFLFlBQVksRUFBRSxPQUFPO0lBQzVCLFFBQVEsRUFBRSxNQUFNLEVBQUUsTUFBTTtJQUN4QixHQUFHLEVBQUUsTUFBTSxFQUFFLGNBQWM7SUFDM0IsUUFBUSxFQUFFLFdBQVc7SUFDckIsR0FBRyxFQUFFLEtBQUs7SUFDVixLQUFLLEVBQUUsT0FBTztJQUNkLElBQUksRUFBRSxNQUFNO0lBQ1osU0FBUyxFQUFFLFdBQVc7SUFDdEIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsSUFBSSxFQUFFLE1BQU07SUFDWixJQUFJLEVBQUUsTUFBTTtDQUNmLENBQUM7QUFFRixVQUFVLENBQUMsR0FBRyxFQUFFOztJQUNaLElBQUksT0FBTyxDQUFDO0lBQ1osSUFBSSxNQUFNLENBQUMsd0JBQXdCLENBQUMsRUFBRSxDQUFDO1FBQ25DLE9BQU87SUFDWCxDQUFDO0lBQ0QsTUFBTSxDQUFDLHdCQUF3QixDQUFDLEdBQUcsSUFBSSxDQUFDO0lBQ3hDLE1BQU0sT0FBTyxHQUFHLGtCQUFrQixDQUFDO0lBQ25DLE1BQU0sV0FBVyxHQUFHLHVCQUF1QixDQUFDO0lBQzVDLE1BQU0sYUFBYSxHQUFHLHlCQUF5QixDQUFDO0lBQ2hELE1BQU0sYUFBYSxHQUFHLHdCQUF3QixDQUFDO0lBQy9DLE1BQU0sV0FBVyxHQUFHLE1BQUMsTUFBYyxDQUFDLFVBQVUsMENBQUUsV0FBVyxDQUFDLENBQUMseURBQXlEO0lBQ3RILElBQUksQ0FBQyxXQUFXLEVBQUUsQ0FBQztRQUNmLE9BQU87SUFDWCxDQUFDO0lBQ0QsTUFBTSxXQUFXLEdBQUcsV0FBVyxFQUFFLENBQUM7SUFDbEMsU0FBUyxnQkFBZ0I7UUFDckIsSUFBSSxDQUFDO1lBQ0QsTUFBTSxHQUFHLEdBQUcsSUFBSSxHQUFHLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ25DLE1BQU0sTUFBTSxHQUFHLEdBQUcsQ0FBQyxZQUFZLENBQUM7WUFDaEMsTUFBTSxrQkFBa0IsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLGdCQUFnQixDQUFDLElBQUksRUFBRSxDQUFDO1lBQzlELE9BQU8sa0JBQWtCLENBQUM7UUFDOUIsQ0FBQztRQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7WUFDVCxPQUFPLENBQUMsS0FBSyxDQUFDLG9CQUFvQixFQUFFLENBQUMsQ0FBQyxDQUFDO1lBQ3ZDLE9BQU8sRUFBRSxDQUFDO1FBQ2QsQ0FBQztJQUNMLENBQUM7SUFDRCxTQUFTLFdBQVc7UUFDaEIsV0FBVyxJQUFJLElBQUksSUFBSSxXQUFXLENBQUMsUUFBUSxDQUFDO1lBQ3hDLFNBQVMsRUFBRSxzQkFBc0I7WUFDakMsWUFBWSxFQUFFLENBQUM7WUFDZixXQUFXLEVBQUUsUUFBUTtZQUNyQixzREFBc0Q7WUFDdEQsT0FBTyxFQUFFO2dCQUNMLFFBQVEsRUFBRSxhQUFhO2dCQUN2QixRQUFRLEVBQUUsT0FBTztnQkFDakIsY0FBYyxFQUFFLGdCQUFnQixFQUFFO2FBQ3JDO1NBQ0osQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUNELFNBQVMsY0FBYztRQUNuQixXQUFXLElBQUksSUFBSSxJQUFJLFdBQVcsQ0FBQyxRQUFRLENBQUM7WUFDeEMsU0FBUyxFQUFFLHFCQUFxQjtZQUNoQyxZQUFZLEVBQUUsQ0FBQztZQUNmLFdBQVcsRUFBRSxRQUFRO1lBQ3JCLHNEQUFzRDtZQUN0RCxPQUFPLEVBQUU7Z0JBQ0wsUUFBUSxFQUFFLFdBQVc7Z0JBQ3JCLFFBQVEsRUFBRSxPQUFPO2dCQUNqQixjQUFjLEVBQUUsZ0JBQWdCLEVBQUU7YUFDckM7U0FDSixDQUFDLENBQUM7UUFDSCxVQUFVLENBQUMsR0FBRyxFQUFFO1lBQ1osV0FBVyxJQUFJLElBQUksSUFBSSxXQUFXLENBQUMsUUFBUSxDQUFDO2dCQUN4QyxTQUFTLEVBQUUscUJBQXFCO2dCQUNoQyxZQUFZLEVBQUUsQ0FBQztnQkFDZixXQUFXLEVBQUUsUUFBUTtnQkFDckIsc0RBQXNEO2dCQUN0RCxPQUFPLEVBQUU7b0JBQ0wsUUFBUSxFQUFFLGFBQWE7b0JBQ3ZCLFFBQVEsRUFBRSxPQUFPO29CQUNqQixjQUFjLEVBQUUsSUFBSTtvQkFDcEIsY0FBYyxFQUFFLGdCQUFnQixFQUFFO2lCQUNyQzthQUNKLENBQUMsQ0FBQztRQUNQLENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUNiLENBQUM7SUFDRCxjQUFjLEVBQUUsQ0FBQztJQUNqQixNQUFNLENBQUMsZ0JBQWdCLENBQUMsT0FBTyxFQUFFLENBQUMsS0FBWSxFQUFFLEVBQUU7UUFDOUMsTUFBTSxNQUFNLEdBQUcsS0FBSyxDQUFDLE1BQXFCLENBQUM7UUFDM0Msa0JBQWtCO1FBQ2xCLGlDQUFpQztRQUNqQyxjQUFjO1FBQ2QsSUFDSSxNQUFNLENBQUMsT0FBTyxLQUFLLEdBQUc7ZUFDbkIsTUFBTSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUM7ZUFDbkIsTUFBTSxDQUFDLFlBQVksQ0FBQyxpQkFBaUIsQ0FBQztlQUN0QyxNQUFNLENBQUMsT0FBTyxDQUFDLG1CQUFtQixDQUFDO2VBQ25DLE1BQU0sQ0FBQyxPQUFPLEtBQUssUUFBUTtlQUMzQixNQUFNLENBQUMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxFQUM3QixDQUFDO1lBQ0MsV0FBVyxFQUFFLENBQUM7UUFDbEIsQ0FBQztJQUNMLENBQUMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQyxFQUFFLEdBQUcsQ0FBQyxDQUFDIn0=